module.exports = __webpack_public_path__ + "assets/a1ae85ba2b808c94a19b2533909801c0.mp3";